<rt-button
  variant="outlined"
  rt-overlay-origin
  (click)="dropdown.open = true"
  [dropdownOpened]="dropdown.open"
  #limitSelectorDropdownTrigger="rtOverlayOrigin"
>
  <rt-icon name="sort"></rt-icon>
  {{ 'app.search.per_page' | translate }}: {{ limit }}
</rt-button>
<ng-template
  #dropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [open]="dropdown.open"
  [origin]="limitSelectorDropdownTrigger"
  (backdropClick)="dropdown.open = false"
>
  <rt-dropdown [width]="DropdownWidth.SmallXX">
    <rt-dropdown-item
      *ngFor="let option of limitOptions; trackBy: trackByOptionValue"
      [highlighted]="option === limit"
      (click)="limitChange.emit(option); dropdown.open = false"
    >
      {{ option }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
